export const FIT_SIZES = [
  { id: "1-10", labelKey: "signup_fit.size_1_10" },
  { id: "11-50", labelKey: "signup_fit.size_11_50" },
  { id: "51-200", labelKey: "signup_fit.size_51_200" },
  { id: "200+", labelKey: "signup_fit.size_200" },
];

export const FIT_GOALS = [
  "channels",
  "ecommerce",
  "survey",
  "voc",
  "market",
];

const GOAL_TO_PRODUCT = {
  channels: "sonic_prospect_channels",
  ecommerce: "sonic_prospect_ecommerce",
  survey: "survey",
  voc: "voice_of_customer",
  market: "market_intelligence",
};

export function recommendSignupProducts({ size: _size, goals = [] } = {}) {
  const recommended = [];
  const selected = new Set(goals);

  ["channels", "ecommerce", "survey"].forEach((goal) => {
    if (selected.has(goal)) recommended.push(GOAL_TO_PRODUCT[goal]);
  });

  if (selected.has("voc") && selected.has("market")) {
    recommended.push("full_intelligence");
  } else {
    if (selected.has("voc")) recommended.push(GOAL_TO_PRODUCT.voc);
    if (selected.has("market")) recommended.push(GOAL_TO_PRODUCT.market);
  }

  return recommended;
}
